const initBackToTop = () => {
  const button = document.querySelector('[data-back-to-top]')

  if (! button) {
    return
  }

  const toggleVisibility = () => {
    button.classList.toggle('is-visible', window.scrollY > 360)
  }

  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  })

  window.addEventListener('scroll', toggleVisibility, { passive: true })
  toggleVisibility()
}

export default initBackToTop



// WEBPACK FOOTER //
// ./resources/assets/js/components/back-to-top.js